import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=99ab87a8&scoped=true"
import script from "./WechatLogin.vue?vue&type=script&lang=js"
export * from "./WechatLogin.vue?vue&type=script&lang=js"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=99ab87a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ab87a8",
  null
  
)

export default component.exports